import React, { useRef, useState } from 'react';
import * as Yup from "yup";
import Breadcrumbs from '../../components/BreadCrumbs';
import { Form, Formik } from 'formik';
import InputField from '../../components/inputFields/InputField';
import Button from '../../components/buttons/Button';
import { useNavigate } from 'react-router-dom';
import FormikDropdown from '../../components/inputFields/FormikDropDown';
import ReceiptComponent from '../../components/RecepitComponent';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import AsyncFormikDropdown from '../../components/inputFields/AsyncFormikDropDown';
import { searchMasterPatientApi } from '../../services/clinic/patient_search';
import { addNewInvoices, sendInvoiceVericifationOtp } from '../../services/clinic/invoice';
import { toast } from 'react-toastify';
import { getUserName } from '../../utils/localStoarege';
import { convertAmountToWords } from '../../utils/ConvertToWords';
import FormikMultiSelectDropdown from '../../components/inputFields/FormikMultiSelectDropdown';
import CustomLoading from '../../components/customLoading/CustomLoading';
import { HiRefresh } from 'react-icons/hi';

function AddInvoice() {
    const navigate = useNavigate();
    const receiptRef = useRef();
    const [userOptions, setUserOptions] = useState([]);
    const [isPdfVisible, setPdfVisible] = useState(false);
    const [otpText, setOtpText] = useState("");
    const [responseOtp, setResponseOtp] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);

    const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const formData = new FormData();
            formData.append("patient_id", values.patient_sn);
            formData.append("name", values.name);
            formData.append("phone", values.phone);
            formData.append("alternate_phone", values.alternate_phone);
            formData.append("machine_name", getUserName());
            formData.append("amount", values.amount);
            formData.append("mode", values.mode);
            formData.append("centre_name", values.center);
            formData.append("package_type", values.package);
            formData.append("transaction_no", values.transaction_number);
            formData.append("remark", values.remark);
            if (values.mode === "Cash") {
                if (otpText.length === 0) {
                    toast.error("Provide OTP");
                    return;
                } else if (otpText !== responseOtp) {
                    toast.error("Wrong OTP Provided");
                    return;
                }
            }
            setShowOverlay(true);
            const response = await addNewInvoices(formData);

            if (response?.status === 201) {
                toast.success("Invoice Generated successfully!");
                setPdfVisible(true);
                setTimeout(() => {
                    downloadPdf(values);
                    setTimeout(() => {
                        resetForm();
                        navigate(-1);
                    }, 2000);
                }, 1000);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
        setShowOverlay(true);
    };

    const handleOtpSend = async (values) => {
        try {
            const formData = new FormData();
            formData.append("mobile_number", values.alternate_phone);
            const response = await sendInvoiceVericifationOtp(formData);

            if (response?.status === 200) {
                toast.success("OTP Sent successfully!");
                setResponseOtp(response.data.otp);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
    };

    const downloadPdf = async (values) => {
        const element = receiptRef.current;

        // Use html2canvas to capture the component
        const canvas = await html2canvas(element, { scale: 2 }); // Higher scale for better quality
        const imgData = canvas.toDataURL('image/png'); // Convert canvas to image data

        // Create a PDF using jsPDF
        const pdf = new jsPDF('p', 'mm', 'a5');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(values.name);
        setTimeout(() => {
            setPdfVisible(false);
        }, 1000);
    };

    const handleDiscardChanges = (resetForm) => {
        resetForm(); // Reset the form
        navigate("/package-invoice"); // Redirect to invoice page
    };

    const handleOtpFill = (value) => {
        if (value) {
            if (otpText.length !== 0) {
                if (otpText.length < 4) {
                    setOtpText(otpText + value);
                }
            } else {
                setOtpText(value);
            }
        } else {
            let updatedText = otpText.slice(0, -1);
            setOtpText(updatedText);
        }
    };

    return (
        <>
            <Breadcrumbs items={[
                { name: 'Home', link: '/invoice' },
                { name: 'Add Invoice' },
            ]} />
            <div className="mt-8">
                <Formik
                    initialValues={{
                        name: "",
                        phone: "",
                        alternate_phone: "",
                        amount: "",
                        patient_sn: "",
                        center: "",
                        mode: "UPI",
                        package: ['FULL BODY'],
                        transaction_number: "",
                        otp: "",
                        remark: "",
                    }}
                    validationSchema={Yup.object({
                        name: Yup.string().required("Please enter a name"),
                        phone: Yup.string().required("Please enter a phone number").min(10),
                        amount: Yup.number().required("Please enter an amount"),
                        mode: Yup.string().required("Please select a payment mode"),
                        package: Yup.array().required("Please select package"),
                    })}
                    onSubmit={handleFormSubmit}
                >
                    {({ isSubmitting, setFieldValue, resetForm, values }) => (
                        <Form onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                            }
                        }}>
                            <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-4">
                                <div className="flex flex-col w-full">
                                    <div className="flex flex-row gap-2 items-end">
                                        <AsyncFormikDropdown
                                            label="Patient ID"
                                            name="patient"
                                            placeholder="Select Patient"
                                            apiCallFunction={async (input) => {
                                                const response = await searchMasterPatientApi(input);
                                                setUserOptions(response.data);
                                                return response.data.map((patient) => ({
                                                    value: patient.id,
                                                    label: `${patient.patient_name} | ${patient.patient_phone}`,
                                                }));
                                            }}
                                            required
                                            needSearch={true}
                                            onChange={(selectedOption) => {
                                                // Find the corresponding patient data                                            
                                                const selectedPatient = userOptions.find(
                                                    (item) => item.id === selectedOption.value
                                                );

                                                if (selectedPatient) {
                                                    setFieldValue("name", selectedPatient.patient_name);
                                                    setFieldValue("phone", selectedPatient.patient_phone);
                                                    setFieldValue("alternate_phone", selectedPatient.patient_phone);
                                                    setFieldValue("patient_sn", selectedPatient.id);
                                                    setFieldValue("center", selectedPatient.center_name);
                                                }
                                            }}
                                        />
                                        <Button
                                            type="button"
                                            className="text-primary bg-white hover:bg-white-dark font-sm aspect-square rounded-lg text-lg p-8 text-center border border-primary"
                                            onClick={resetForm}
                                            disabled={isSubmitting}
                                        >
                                            <HiRefresh />
                                        </Button>
                                    </div>
                                    <InputField
                                        label="Patient SN"
                                        name="patient_sn"
                                        type="text"
                                        placeholder="Patient SN"
                                        disable
                                    />
                                    <InputField
                                        label="Center"
                                        name="center"
                                        type="text"
                                        placeholder="Center Name"
                                        disable
                                    />
                                    <InputField
                                        label="Name"
                                        name="name"
                                        type="text"
                                        placeholder="Enter Name"
                                        required
                                        disable
                                    />
                                    <InputField
                                        label="Phone"
                                        name="phone"
                                        type="text"
                                        placeholder="Enter Phone Number"
                                        required
                                        disable
                                    />
                                    <InputField
                                        label="Alt. Phone"
                                        name="alternate_phone"
                                        type="text"
                                        placeholder="Enter Phone Number"
                                    />
                                    <InputField
                                        label="Amount"
                                        name="amount"
                                        type="text"
                                        placeholder="Enter Amount"
                                        required
                                    />
                                    <FormikMultiSelectDropdown
                                        label="Package"
                                        name="package"
                                        placeholder="Select Package"
                                        required={true}
                                        options={[
                                            { label: "FULL BODY", value: "FULL BODY" },
                                            { label: "TPT", value: "TPT" },
                                            { label: "HAND", value: "HAND" },
                                            { label: "FEET", value: "FEET" },
                                        ]}
                                    />
                                    <FormikDropdown
                                        label="Mode"
                                        name="mode"
                                        placeholder="Select Mode"
                                        required={true}
                                        options={[
                                            { label: "NEFT", value: "NEFT" },
                                            { label: "Cash", value: "Cash" },
                                            { label: "UPI", value: "UPI" },
                                            { label: "Card", value: "Card" },
                                            { label: "Cheque", value: "Cheque" },
                                        ]}
                                    />
                                    {
                                        values.mode === "UPI" || values.mode === "Card" || values.mode === "Cheque" ?
                                            <InputField
                                                label={`${values.mode} Number`}
                                                name="transaction_number"
                                                placeholder={`Enter ${values.mode} Number`}
                                            /> : <></>
                                    }
                                    {
                                        values.mode === "Cash" ?
                                            <Button
                                                type="button"
                                                className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                                onClick={() => handleOtpSend(values)}>
                                                Generate OTP
                                            </Button>
                                            : <></>
                                    }
                                    {
                                        values.mode === "Cash" ?
                                            <InputField
                                                label="OTP"
                                                name="otp"
                                                placeholder={"Enter OTP"}
                                                type="number"
                                                value={otpText}
                                                onChange={(val) => handleOtpFill(val.nativeEvent.data)}
                                                required
                                            />
                                            : <></>
                                    }
                                    <InputField
                                        label="Remark"
                                        name="remark"
                                        type="text"
                                        placeholder="You can add a remark here"
                                    />
                                    <div className="py-5 flex justify-end gap-6">
                                        <div>
                                            <Button
                                                type="button"
                                                className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                                onClick={() => handleDiscardChanges(resetForm)}
                                                disabled={isSubmitting}
                                            >
                                                Discard Changes
                                            </Button>
                                        </div>
                                        <div>
                                            <Button
                                                type="submit"
                                                className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                                disabled={isSubmitting || values.mode === "Cash" && responseOtp === null}
                                            >
                                                {isSubmitting ? "Saving..." : "Save"}
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                {/* Receipt Preview */}
                                <div className="flex flex-col justify-start w-full my-2">
                                    <span className="mb-2">
                                        <StyledHeadingText text={"Preview"} />
                                    </span>
                                    <div ref={receiptRef} className={isPdfVisible ? "" : "hidden"}>
                                        <ReceiptComponent
                                            name={values.name || "N/A"}
                                            amount={values.amount || 0}
                                            paymentMode={values.mode || "N/A"}
                                            receiptNo={Math.floor(Math.random() * 10000)}
                                            phone={values.phone || "N/A"}
                                            packageType={values.package}
                                            remark={values.remark}
                                            amountInWords={
                                                values.amount
                                                    ? `${convertAmountToWords(values.amount)}`
                                                    : "Zero Only"
                                            }
                                            transactionNumber={values.transaction_number}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
            {
                showOverlay ?
                    <div className="absolute flex flex-row justify-center items-center top-0 left-0 w-full h-full bg-[#0000006f]">
                        <CustomLoading />
                    </div>
                    : <></>
            }
        </>
    );
}

export default AddInvoice;
